(ns iris.websocket.online-users
  (:require [re-frame.core :as rf]))

(rf/reg-event-db
 :iris.online-users/user-active
 (fn [db [_ user-id]]
   (js/console.log "User active:" user-id)
   ;; Just add to Set - count will be derived automatically
   (update db :online-users (fnil conj #{}) user-id)))

(rf/reg-event-db
 :iris.online-users/set-list
 (fn [db [_ users count]]
   (js/console.log "Setting online users:" users "count:" count)
   ;; Store ONLY the Set, not the count
   (assoc db :online-users (into #{} users))))

(rf/reg-sub
 :iris.online-users/count
 (fn [db _]
   (get-in db [:online-users :count] 0)))

(rf/reg-sub
 :iris.online-users/users
 (fn [db _]
   (get-in db [:online-users :users] #{})))